import { SyncEventType } from '../../enums/syncEventType';
import { PersistenceEvent } from './persistenceEvent';

export class EventSprintDeleted implements PersistenceEvent {

  public readonly type = SyncEventType.SPRINT_DELETED;
  public sprintId: number;

  constructor(sprintId: number) {
    this.sprintId = sprintId;
  }

  getPayload(): object {
    const payload = {
      'sprintId': this.sprintId
    };
    return payload;
  }

  static fromPayload(payload: any): EventSprintDeleted {
    return new EventSprintDeleted(
      payload['sprintId']
    );
  }

}

